import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSquaresStacked = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "2.5em",
	height: "2.5em",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M24 16H30V30H16V24",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M24 10H10V24H24V10Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	})]
});
const ForwardRef = forwardRef(SvgSquaresStacked);
export default ForwardRef;
